// extracted by mini-css-extract-plugin
module.exports = {"businessTextCaptionContainer":"business-text-caption_businessTextCaptionContainer__91a1S","businessTextCaption":"business-text-caption_businessTextCaption__PYuih"};